// Function to get last 5 characters and concatenate them with the full key
export const formatPublicKey = (publicKey) => {
  if (!publicKey || publicKey.length < 5) return publicKey; // Return original if too short or null
  const lastFive = publicKey.slice(-5); // Get last 5 characters
  return `...${lastFive}`; // Concatenate full key with last five characters
};
